import { UI_HeaderCard } from 'ui/components/2-molecules/Card/HeaderCard/HeaderCard';
import { DynamicModule } from '1-project/DynamicModule/DynamicModule';
import { GoToTopNavigation } from '2-feature/Navgation/GoToTopNavigation';
import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { MainRegion } from '1-project/MainRegion/MainRegion';

interface Props extends Content.Page {
	properties: Content.ArticlePageProperties;
}

export const ArticlePage = ({ properties }: Props) => {
	const { author, pageSections, kicker } = properties ?? {};
	const dictionary = useDictionaryContext();

	const kickerParts = [kicker?.trim(), author?.fullName?.trim() && `${dictionary.getLabel('WrittenBy')} ${author.fullName.trim()}`].filter(Boolean);
	const kickerCombined = kickerParts.length ? kickerParts.join(' - ') : null;

	return (
		<MainRegion>
			<UI_HeaderCard {...properties} kicker={kickerCombined} />
			{pageSections.map((pageSection, index) => (
				<DynamicModule key={index} module={pageSection} />
			))}
			<GoToTopNavigation />
		</MainRegion>
	);
};
